import React, { useState } from "react";
import {
  CampaignCard,
  CampaignText,
  HorizontalLine,
  CampaignCost
} from "../BookingOverview.styled";
import { Collapse } from "../../../../../Components/Layout";
import useChannelsIcon from "../../../../Campaign/DataVisualization/hooks/useChannelsIcon";
import moment from "moment";
import { BoxIcon } from "../../../../../Components/NewMetricsReport/PrintChannels/PrintChannels.styled";
import {
  CampaignTable,
  ChannelIcons,
  NumLocations,
  TableItem,
  TableItemField,
  TableItemTitle,
  TableJobTitle
} from "./Section.styled";
import { useTranslation } from "react-i18next";
import { BookingCollapse } from "../utils/BookingCollapse";
import { Tooltip } from "../../../../../Components/Overlays";
import { formatIntlNumber } from "../../../../../utils/Helpers";

export const CampaignSection = ({
  jobTitle,
  companyName,
  startDate,
  location,
  campaignDuration,
  selectedChannels,
  campaignBudget,
  language
}) => {
  const { t } = useTranslation();
  const { renderIcons } = useChannelsIcon();
  const [collapse, setCollapse] = useState(true);

  const budget = formatIntlNumber(campaignBudget, { language, points: 2 });

  moment.locale(language ?? "de");

  const campaignTableInfo = [
    {
      header: t("Company Name"),
      field: companyName
    },
    {
      header: t("Start Date"),
      field: startDate ? (
        <>
          {moment(startDate).format("DD.MM.YYYY")} <br /> {moment().to(startDate)}
        </>
      ) : (
        t("As of now")
      )
    },
    {
      header: t("Location"),
      field: (
        <>
          {location[0].location}
          {location.length > 1 ? (
            <Tooltip
              bgColor="#000"
              label={location
                .slice(1)
                .map(({ location }) => location)
                .join(", ")}
            >
              <NumLocations>+{location.length - 1}</NumLocations>
            </Tooltip>
          ) : null}
        </>
      )
    },
    {
      header: t("Duration"),
      field: t("{{duration}} days", { duration: campaignDuration })
    },
    {
      header: t("Channels"),
      field: selectedChannels,
      transform: "icons"
    }
  ];

  const renderTableItem = (field, transform) => {
    if (transform === "icons") {
      return (
        <ChannelIcons>
          {field.map(({ channel_short_name }) => (
            <Tooltip key={channel_short_name} bgColor="#000" label={channel_short_name}>
              <BoxIcon data-testid={`${channel_short_name}-icon`}>
                {renderIcons(channel_short_name)}
              </BoxIcon>
            </Tooltip>
          ))}
        </ChannelIcons>
      );
    }
    return <TableItemField>{field}</TableItemField>;
  };

  return (
    <CampaignCard onClick={() => setCollapse(!collapse)}>
      <Collapse
        parent={
          <BookingCollapse
            collapse={collapse}
            title={t("Campaign")}
            dataTip={t("Results from the channels and the requirements")}
            cost={budget}
          />
        }
        show={collapse}
      >
        <CampaignText>
          <CampaignTable>
            <TableJobTitle>
              <TableItemTitle>{t("Job title")}: </TableItemTitle>
              <TableItemField>{jobTitle}</TableItemField>
            </TableJobTitle>
          </CampaignTable>
          <CampaignTable>
            {campaignTableInfo.map(({ header, field, transform }) => {
              return (
                <TableItem key={header}>
                  <TableItemTitle>{header}</TableItemTitle>
                  {renderTableItem(field, transform)}
                </TableItem>
              );
            })}
          </CampaignTable>
        </CampaignText>
        <HorizontalLine />
        <CampaignCost>{budget} €</CampaignCost>
      </Collapse>
    </CampaignCard>
  );
};
